import type { Tone } from '@client/components/_ui/display/TonePill';
import type { AppModule } from '@shared/constants';
import type { HomeItem } from '@shared/constants/business/lite';

export type UrgencyChipTone = Exclude<Tone, 'ok'>;

export type UrgencyChipData = {
    label: string;
    tone: UrgencyChipTone;
};

export type MetricCardV2Data = {
    /** The Home item kind this card belongs to; a Lite org sees only `LITE_ENABLED_HOME_ITEMS`. */
    homeItem: HomeItem;
    title: string;
    count: number;
    icon: React.ComponentType<{ size?: number; className?: string }>;
    color: string;
    /** Urgency splits shown under the count (overdue / due soon / awaiting review). */
    chips: UrgencyChipData[];
    /** Honest one-liner under the chips (composition, oldest age). */
    footnote?: string;
    /** Created-in-the-last-7-days count; rendered top-right when > 0. */
    newThisWeek?: number;
    /** Marks entities that are new to the grid (attestations, conflicts). */
    isNew?: boolean;
    onClick: () => void;
    /** Register-specific explanation used when this card has no work to show. */
    emptyStateMessage: string;
    /** Card shows if ANY of these modules are enabled. */
    requiredModules?: AppModule[];
};

export const MY_ITEMS_VIEWS = ['cards', 'focus'] as const;
export type MyItemsView = (typeof MY_ITEMS_VIEWS)[number];

export const MY_ITEMS_VIEW_SETTING_KEY = 'myItemsView';
